/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleAutocompleteSuggestion } from './APIArticleAutocompleteSuggestion';
import {
    APIArticleAutocompleteSuggestionFromJSON,
    APIArticleAutocompleteSuggestionFromJSONTyped,
    APIArticleAutocompleteSuggestionToJSON,
} from './APIArticleAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIAutocompleteResponse
 */
export interface APIAutocompleteResponse {
    /**
     * 
     * @type {Array<APIArticleAutocompleteSuggestion>}
     * @memberof APIAutocompleteResponse
     */
    suggestions: Array<APIArticleAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIAutocompleteResponse interface.
 */
export function instanceOfAPIAutocompleteResponse(value: object): value is APIAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIAutocompleteResponseFromJSON(json: any): APIAutocompleteResponse {
    return APIAutocompleteResponseFromJSONTyped(json, false);
}

export function APIAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIArticleAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIAutocompleteResponseToJSON(value?: APIAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIArticleAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

